<div class="row sub-title" (click)="open ? open = false : open = true">
    <div class="col-12">
        <img src="/assets/images/icons/add.svg" *ngIf="!open" />
        <img src="/assets/images/icons/minus.svg" *ngIf="open" />
        <span class="font-mont-semi-bold">Notes</span>
    </div>
</div>
<div class="row container" [ngClass]="{ 'open': open }">
    <div class="col-12">
        <form [formGroup]="form" (ngSubmit)="onFormSubmit();">
            <textarea rows="5" formControlName="notes" class="form-control" id="notes" name="notes"></textarea>
            <button type="submit" class="btn btn-secondary close-button">Save Notes</button>
        </form>
    </div>
</div>